// client side errors
export const ERROR_CODE_PARSING = 'parsing_error'
export const ERROR_CODE_GENERIC = 'generic_error'

// server side errors
export const ERROR_CODE_SERVER_PARSING = 'server_parsing_error' // HTTP 500
export const ERROR_CODE_SERVER_BAD_ENDPOINT_NAME = 'bad_endpoint_name' // HTTP 400
export const ERROR_CODE_SERVER_GENERIC = 'server_generic_error' // HTTP 500
export const ERROR_CODE_INVALID_RESPONSE_FORMAT = 'invalid_response_format' // HTTP 400
